import axios from 'axios';
import { setupInterceptors } from './interceptors';

// Base URL for API requests
const baseURL = process.env.REACT_APP_API_URL || 'https://api.zven.app';

// Create Axios instance with default config
export const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 3000000, // 10 seconds
});

// Setup request/response interceptors
setupInterceptors(apiClient);

export default apiClient;